import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { BuyTogether } from '../../../../vtex-apps/BuyTogether/default';
import { v4 as uuidv4 } from 'uuid';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function BuyTogetherGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'BuyTogetherGroup',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Compre Junto (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'buyTogether-group-1__flex-row', mzTitle: 'MZ | Compre Junto' }, [
				FlexLayoutCol({}, [
					BuyTogether(
						{ title: 'Compre junto', blockClass: 'buyTogether-sect-1' },
						[
							SliderLayout({
								infinite: false,
								listElement: 'ul',
								itemElement: 'li',
								blockClass: 'buy-together__list',
								itemsPerPage: {
									desktop: 2,
									tablet: 2,
									phone: 1,
								},
								showPaginationDots: 'never',
								// não mudar este, por que o app tem css interno usando isso "buy-together-selectable-box" como children
								// exemplo no final deste arquivo
							}),
						],
						//blocks
						[
							{
								componentGroup: 'ProductSummaryShelf',
								componentName: 'ProductSummaryShelfComponent',
								componentId: uuidv4(),
								//para adicionar o selectable esta prateleira deve ter o bloco
							},
						],
					),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--brand-color-primary-pure', to: '--bt-1-title-color', name: 'Title' },
			{ from: '--brand-color-primary-pure', to: '--bt-1-heading-color', name: 'Heading' },
			{ from: '--white', to: '--bt-1-background-color', name: 'Background' },
			{ from: '--cta-color-pure', to: '--bt-1-button-color', name: 'Buy Button background' },
			{ from: '--cta-color-hover', to: '--bt-1-buttonHover-color', name: 'Buy Button hover background' },
			{ from: '--white', to: '--bt-1-button-name-text-color', name: 'Buy Button font' },
			{ from: '--transparent', to: '--bt-1-border-card-color', name: 'Buy Button Card Border' },
			{ from: '--text-color-1', to: '--bt-1-selling-name-text-color', name: 'Selling Price' },
			{ from: '--text-color-1', to: '--bt-1-list-name-text-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--bt-1-installment-name-text-color', name: 'Installment Price' },
			{ from: '--text-color-1', to: '--bt-1-subtitle-name-text-color', name: 'Subtitle Price' },
			{ from: '--text-color-1', to: '--bt-1-subtitleSelling-name-text-color', name: 'Subtitle Selling Price' },
			{ from: '--neutral-color-high-medium', to: '--bt-1-border-ProductCard-color', name: 'ProductCard Border' },
			{ from: '--neutral-color-high-light', to: '--bt-1-background-card-color', name: 'PriceCard background' },
			{ from: '--brand-color-primary-pure', to: '--bt-1-equals-text-color', name: 'Simbol "="' },
			{ from: '--brand-color-primary-pure', to: '--bt-1-plus-text-color', name: 'Simbol "+"' },
			{ from: '--brand-color-primary-pure', to: '--bt-1-selectable-check-color', name: 'Select box' },
			{ from: '--text-color-1', to: '--bt-1-select-color', name: 'Select text' },
			{
				from: '--brand-color-primary-pure',
				to: '--bt-1-arrow-button-background-color',
				name: 'Arrow button background',
			},
			{
				from: '--brand-color-primary-dark',
				to: '--bt-1-arrow-button-background-hover-color',
				name: 'Arrow button hover background',
			},
			{ from: '--white', to: '--bt-1-arrow-background-color', name: 'Arrow  background' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--bt-1-button-br', name: 'Buy Button' },
			{ from: '--border-radius-sm', to: '--bt-1-card-br', name: 'Card' },
			{ from: '--border-radius-sm', to: '--bt-1-plus-br', name: 'Simbol "+"' },
			{ from: '--border-radius-sm', to: '--bt-1-arrow-br', name: 'Arrow button' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--bt-1-heading-fw', name: 'Heading' },
			{ from: '--font-weight-700', to: '--bt-1-title-fw', name: 'Title' },
			{ from: '--font-weight-700', to: '--bt-1-button-name-fw', name: 'Buy Button' },
			{ from: '--font-weight-700', to: '--bt-1-selling-name-fw', name: 'Selling Price' },
			{ from: '--font-weight-700', to: '--bt-1-list-name-fw', name: 'List Price' },
			{ from: '--font-weight-700', to: '--bt-1-installment-name-fw', name: 'Installment Price' },
			{ from: '--font-weight-700', to: '--bt-1-subtitle-name-fw', name: 'Subtitle Price' },
			{ from: '--font-weight-700', to: '--bt-1-subtitleSelling-name-fw', name: 'Subtitle Selling Price' },
			{ from: '--font-weight-500', to: '--bt-1-select-fw', name: 'Select text' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--bt-1-heading-fs', name: 'Heading' },
			{ from: '--font-size-xxl', to: '--bt-1-title-fs', name: 'Title' },
			{ from: '--font-size-sm', to: '--bt-1-button-name-fs', name: 'Buy Button' },
			{ from: '--font-size-sm', to: '--bt-1-selling-name-fs', name: 'Selling Price' },
			{ from: '--font-size-sm', to: '--bt-1-list-name-fs', name: 'List Price' },
			{ from: '--font-size-sm', to: '--bt-1-installment-name-fs', name: 'Installment Price' },
			{ from: '--font-size-sm', to: '--bt-1-subtitle-name-fs', name: 'Subtitle Price' },
			{ from: '--font-size-sm', to: '--bt-1-subtitleSelling-name-fs', name: 'Subtitle Selling Price' },
			{ from: '--font-size-sm', to: '--bt-1-select-fs', name: 'Select Text' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--bt-1-heading-ff', name: 'Heading' },
			{ from: '--main-font', to: '--bt-1-title-ff', name: 'Title' },
			{ from: '--main-font', to: '--bt-1-button-name-ff', name: 'Buy Button' },
			{ from: '--main-font', to: '--bt-1-selling-name-ff', name: 'Selling Price' },
			{ from: '--main-font', to: '--bt-1-list-name-ff', name: 'List Price' },
			{ from: '--main-font', to: '--bt-1-installment-name-ff', name: 'Installment Price' },
			{ from: '--main-font', to: '--bt-1-subtitle-name-ff', name: 'Subtitle Price' },
			{ from: '--main-font', to: '--bt-1-subtitleSelling-name-ff', name: 'Subtitle Selling Price' },
			{ from: '--main-font', to: '--bt-1-select-ff', name: 'Select text' },
		],
	},
];

// EX:
// "product-summary.shelf#buy-together": {
//    "title": "Sumário do produto",
//    "children": [
//        // "product-summary.shelf#shelf-ProductSummaryShelf-1"
//        "add-to-list-btn#shelf-Wishlist-1",
//        "flex-layout.row#shelf-FlexLayoutRow-1",
//        "buy-together-selectable-box"
//    ],
//    "props": {
//        "blockClass": [
//            "product__summary",
//            "product__summary--shelf",
//            "product__summary--buy-together"
//        ],
//        "priceBehavior": "default",
//        "trackListName": true
//    }
// },
